import { render } from "./vacancy.vue?vue&type=template&id=72709690&scoped=true&ts=true"
import script from "./vacancy.vue?vue&type=script&lang=ts"
export * from "./vacancy.vue?vue&type=script&lang=ts"

import "./vacancy.vue?vue&type=style&index=0&id=72709690&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72709690"]])

export default __exports__